import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  cloudBucketFileName: string;
  fileName: string;
}

export const useDownloadTraceFileFromCloud = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ cloudBucketFileName, fileName }: HookProps) => {
      const response = await request({
        path: 'batches/download-trace-file',
        method: 'POST',
        authenticate: true,
        fileDownload: true,
        dataObject: { cloudBucketFileName, fileName },
      });
      const href = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully downloaded the old file!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the old file!');
    },
  });
};
